import { render } from "./InvoiceView.vue?vue&type=template&id=33b011a7&scoped=true&ts=true"
import script from "./InvoiceView.vue?vue&type=script&lang=ts"
export * from "./InvoiceView.vue?vue&type=script&lang=ts"

import "./InvoiceView.vue?vue&type=style&index=0&id=33b011a7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33b011a7"]])

export default __exports__